@if(isDisabled){
<app-loader></app-loader>
}
<form name="UserForm" (ngSubmit)="UserForm.form.valid && Validate(UserForm)" #UserForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>User Details</label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <label class="form-label">First Name <span class="text-danger">*</span></label>
                    <input name="firstName" class="form-control" placeholder="Enter First Name"
                        [(ngModel)]="Detail.FirstName" #firstName="ngModel" required>
                    <div class="invalid-feedback fs-7">
                        Please enter first name
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Middle Name</label>
                    <input name="middleName" class="form-control" placeholder="Enter Middle Name"
                        [(ngModel)]="Detail.MiddleName" #middleName="ngModel">
                    <div class="invalid-feedback fs-7">
                        Please enter middle name.
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Last Name <span class="text-danger">*</span></label>
                    <input name="lastName" class="form-control" placeholder="Enter Last Name"
                        [(ngModel)]="Detail.LastName" #lastName="ngModel" required>
                    <div class="invalid-feedback fs-7">
                        Please enter last name
                    </div>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-md-4">
                    <label class="form-label">Designation</label>
                    <div class="input-group">
                        <input name="designation" class="form-control" placeholder="Enter Designation"
                            [(ngModel)]="Detail.Designation" #designation="ngModel">
                        <div class="invalid-feedback fs-7">
                            Please enter designation.
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Email ID</label>
                    <input name="emailID" type="email" class="form-control" placeholder="Enter Email ID"
                        [(ngModel)]="Detail.EmailID" #emailID="ngModel">
                    <div class="invalid-feedback fs-7">
                        Please enter email id
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Phone</label>
                    <input (keypress)="common.NumberOnly($event)" [maxlength]="10" [minlength]="10" name="Phone"
                        class="form-control" placeholder="Enter Phone" [(ngModel)]="Detail.Phone" #Phone="ngModel">
                    <div class="invalid-feedback fs-7">
                        Please enter phone.
                    </div>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-md-6">
                    <label class="form-label">Address</label>
                    <textarea class="form-control" name="Address" id="Address" rows="3"
                        placeholder="Please Enter Address" [(ngModel)]="Detail.Address"></textarea>
                </div>
                <div class="col-auto mt-4">
                    <input class="form-check-input" name="active" id="Active" type="checkbox"
                        [(ngModel)]="Detail.IsActive" value="" [disabled]="Detail.UserMasterId > 0 && !Detail.IsActiveBackend" />&nbsp;&nbsp;
                    <label class="text-label-dark" for="checkbox">
                        Is Active</label>
                </div>
                <div class="col-auto mt-4">
                    <input class="form-check-input" name="IsSuperAdmin" id="isSuperAdmin" type="checkbox"
                        [(ngModel)]="Detail.IsSuperAdmin" value="" />&nbsp;&nbsp;
                    <label class="text-label-dark" for="checkbox">
                        Is Super Admin</label>
                </div>

                <!-- <div class="col-auto mt-4">
                    <input class="form-check-input" name="UserApprovalFlag" id="userApprovalFlag" type="checkbox"
                        [(ngModel)]="Detail.IsUserApprovalFlag" value="" />&nbsp;&nbsp;
                    <label class="text-label-dark" for="checkbox">
                        User Approval Flag</label>
                </div> -->
            </div>

            <div class="row mt-2">
                <div class="col-auto">
                    <label class="form-label">User Type <span class="text-danger">*</span></label><br>
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-2" ngbButtonLabel *ngFor="let pc of UserType; let i = index">
                            <input class="form-check-input" type="radio" [value]="pc.Value" name="usertype{{i}}"
                                [(ngModel)]="Detail.userType_new" [ngModelOptions]="{standalone: true}">
                            {{pc.Label}}
                        </label>
                    </div>
                </div>
            </div>

            <!-- <div class="row mt-3">
                <div class="col-md-4">
                    <label class="form-label">Maker-Checker Option <span class="text-danger">*</span></label><br>
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-2" ngbButtonLabel
                            *ngFor="let pc of MakerCheckerOption">
                            <input class="form-check-input" type="radio" [value]="pc.Value" name='makercheckeroption'
                                [(ngModel)]="Detail.MakerChecker" [ngModelOptions]="{standalone: true}">
                            {{pc.Label}}
                        </label>
                    </div>
                </div>
            </div> -->
        </div>
    </div>

    <div class="card mt-3">
        <div class="card-header">
            <label>Login Details </label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                    <label class="form-label">User Name <span class="text-danger">*</span></label>
                    <input name="userName" class="form-control" placeholder="Enter First Name"
                        [(ngModel)]="Detail.UserName" #firstName="ngModel" [disabled]="Detail.UserMasterId > 0"
                        required>
                    <div class="invalid-feedback fs-7">
                        Please enter user name
                    </div>
                </div>

                <div class="col-md-6">
                    <label for="Profiletype" class="form-label">Profile Type <span class="text-danger">*</span></label>
                    <ng-select name="Profiletype" placeholder="Select Profile Type" [items]="ProfileLoad"
                        bindLabel="ProfileName" bindValue="ProfileMasterID" [(ngModel)]="Detail.ProfileMasterId"
                        required>
                    </ng-select>
                    <div class="invalid-feedback fs-7">
                        Please select profile type
                    </div>
                </div>

                <div class="col-auto mt-3" *ngIf="Detail.UserMasterId > 0">
                    <label class="form-label text-label-dark">Change Password:</label>
                    <input class="form-check-input m-2" type="checkbox" id="passwordchange" name="passwordchange"
                        [(ngModel)]="Detail.IsChangePassword">
                </div>

                <div style="max-width: 405px;" class="col-md-5">
                    <label class="form-label">Password </label>
                    <input name="Password" type="password" class="form-control" placeholder="Enter Password"
                        [(ngModel)]="Detail.Password" #Password="ngModel"
                        [disabled]="!Detail.IsChangePassword && Detail.UserMasterId !== 0">
                    <div class="invalid-feedback fs-7">
                        Please enter password.
                    </div>
                </div>

                <div style="max-width: 405px;" class="col-md-5">
                    <label class="form-label">Confirm Password </label>
                    <input name="ConfirmPassword" type="password" class="form-control"
                        placeholder="Enter Confirm Password" [(ngModel)]="Detail.ConfirmPassword"
                        #ConfirmPassword="ngModel" [disabled]="!Detail.IsChangePassword && Detail.UserMasterId !== 0">
                    <div class="invalid-feedback fs-7">
                        Please enter confirm password
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card mt-3">
        <div class="card-header">
            <label>User Details</label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                    <label class="form-label">Approval User Type</label>
                    <ng-select name="approvaluser" placeholder="Select Profile Type" [items]="ApprovalUserType"
                        bindLabel="l" bindValue="v" [(ngModel)]="Detail.ApprovalUserType">
                    </ng-select>
                    <div class="invalid-feedback fs-7">
                        Please select approval user type
                    </div>
                </div>

                <!-- <div class="col-md-3 mt-4">
                    <input class="form-check-input" name="IsSuperAdmin" id="isSuperAdmin" type="checkbox"
                        [(ngModel)]="Detail.IsSuperAdmin" value="" />&nbsp;&nbsp;
                    <label class="text-label-dark" for="checkbox">
                        Is Super Admin</label>
                </div> -->

                <!-- <div class="col-md-6">
                    <label class="form-label">Confirm Password <span class="text-danger">*</span></label>
                    <input name="ConfirmPassword" type="text" class="form-control" placeholder="Enter Confirm Password"
                        [(ngModel)]="Detail.CPassword" #ConfirmPassword="ngModel" required>
                    <div class="invalid-feedback fs-7">
                        Please enter Confirm Password.
                    </div>
                </div>

                <div class="col-md-6">
                    <label for="Profiletype" class="form-label">Profile Type <span class="text-danger">*</span></label>
                    <ng-select name="Profiletype" placeholder="Select Profile Type" [items]="ProfileLoad"
                        bindLabel="ProfileName" bindValue="ProfileMasterID" [(ngModel)]="Detail.ProfileMasterId"
                        required>
                    </ng-select>
                    <div class="invalid-feedback fs-7">
                        Please select Profile Type.
                    </div>
                </div> -->

                <!-- <div class="col-md-3 mt-4">
                    <input class="form-check-input" name="UserApprovalFlag" id="userApprovalFlag" type="checkbox"
                        [(ngModel)]="Detail.IsUserApprovalFlag" value="" />&nbsp;&nbsp;
                    <label class="text-label-dark" for="checkbox">
                        User Approval Flag</label>
                </div> -->

                <!-- <div class="col-md-6">
                    <label for="fullnfinalapprovaltype" class="form-label">Full n Final Approval</label>
                    <ng-select name="fullnfinalapprovaltype" placeholder="Select Approval Type"
                        [items]="FullnFinalApproval" bindLabel="FnFUserTypeName" bindValue="FnFUserTypeID"
                        [(ngModel)]="Detail.FnFApprovalTypeId">
                    </ng-select>
                    <div class="invalid-feedback fs-7">
                        Please select Full n Final Approval.
                    </div>
                </div> -->

                <div class="col-md-6">
                    <label for="Employeemapping" class="form-label">Employee Mapping</label>
                    <ng-select name="Employeemapping" placeholder="Select Employee Mapping" [items]="EmployeeMapping"
                        bindLabel="Name" bindValue="EmpMasterID" [(ngModel)]="Detail.EmployeeMappingId">
                    </ng-select>
                    <div class="invalid-feedback fs-7">
                        Please select Employee Mapping.
                    </div>
                </div>

                <!-- <div class="row mt-3 card">
                    <div class="card-header">
                        <input class="form-check-input" name="OtherModule" id="otherModule" type="checkbox"
                            [(ngModel)]="Detail.OtherModule" value="" (ngModelChange)="onChange()" />&nbsp;&nbsp; Other
                        Module
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div *ngFor="let row of OtherModuleChunk; let i = index" class="col-12">
                                <div class="row">
                                    <div *ngFor="let userType of row" class="col-4">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox"
                                                [id]="'checkbox-' + userType.ID" [(ngModel)]="userType.checked" />
                                            <label class="form-check-label" [for]="'checkbox-' + userType.ID">
                                                {{ userType.Name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="mt-3">
                    <div class="card">
                        <div class="card-header">
                            <!-- <label>
                                <input class="form-check-input" name="OtherModule" id="otherModule" type="checkbox"
                                    [(ngModel)]="Detail.SelectAll" value="" (ngModelChange)="onChange()" />&nbsp;&nbsp;
                                Select All
                            </label> -->
                            <label>
                                <input class="form-check-input" name="OtherModule" id="otherModule" type="checkbox"
                                    [(ngModel)]="Detail.SelectAll" value="" />&nbsp;&nbsp;
                                Select All
                            </label>
                        </div>
                        <div class="card-body">

                            <!-- <div class="row">
                                <div *ngFor="let module of OtherModule; let i = index" class="col-4">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" name="modulename{{i}}"
                                            [id]="'checkbox-' + module.ID" [(ngModel)]="module.checked" />
                                        <label class="form-check-label" [for]="'checkbox-' + module.ID">
                                            {{ module.Name }}
                                        </label>
                                    </div>
                                </div>
                            </div> -->

                            <!-- <div class="row">
                                <div *ngFor="let module of OtherModule; let i = index" class="col-4">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" name="modulename{{i}}"
                                            [id]="'checkbox-' + module.ID" [(ngModel)]="module.checked" />
                                        <label class="form-check-label" [for]="'checkbox-' + module.ID">
                                            {{ module.Name }}
                                        </label>
                                    </div>
                                </div>
                            </div> -->

                            <!-- <div *ngFor="let group of OtherModule" class="mb-4"> -->

                            <!-- Header -->
                            <h6 class="fw-bold mb-2">Core Modules</h6>

                            <!-- Modules -->
                            <div class="row">
                                <div *ngFor="let module of coreModules | keyvalue; let i = index" class="col-md-3">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" name="coremodulename{{i}}"
                                            [id]="'checkbox-' + module.key" [(ngModel)]="module.value.checked" />
                                        <label class="form-check-label" [for]="'checkbox-' + module.key">
                                            {{ module.key }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <!-- Header -->
                            <h6 class="fw-bold mb-2 mt-3">MaxOps - Mobile</h6>

                            <!-- Modules -->
                            <div class="row">
                                <div *ngFor="let module of maxopsMobile | keyvalue; let i = index" class="col-md-3">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" name="maxopsmodule{{i}}"
                                            [id]="'checkbox-' + module.key" [(ngModel)]="module.value.checked" />
                                        <label class="form-check-label" [for]="'checkbox-' + module.key">
                                            {{ module.key }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <!-- </div> -->
                        </div>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-md-5">
                        <div class="card border-0">
                            <div class="card-body p-0">
                                <div class="row">
                                    <div class="col-auto"><label class="text-label-dark">User Sign</label></div>
                                    <div class="col-auto" ngbDropdown
                                        *ngIf="Detail.UserSignature != null && Detail.UserSignature != ''">
                                        <span> <button class="btn btn-sm" name="view1" type="button"
                                                style="color: blue;" (click)="viewFile('Signature')"><i
                                                    class="bi bi-eye"></i></button></span>
                                        <button class="btn btn-sm" name="delete1" type="button" style="color: red;"
                                            (click)="removeFile('Signature')">
                                            <i class="bi bi-trash"></i>
                                        </button>
                                    </div>
                                </div>
                                <Input id="contained-button-file" (change)="upload($event,'Signature')"
                                    name="filedocimgSignature" accept=".jpeg,.jpg,.png" type="file" #filedocimgSignature
                                    required ngbTooltip="Choose File" style="display: none;" />
                                <div class="col-12 ImageDiv">
                                    <div class="upload-icon cursor-pointer"
                                        *ngIf="Detail.UserSignature == null || Detail.UserSignature == ''"
                                        (click)="filedocimgSignature.click()">
                                        <i class="bi bi-upload"></i>
                                        <br />
                                        <label>Upload</label>
                                    </div>
                                    <div ngbDropdown>
                                        <img style="width: 120px; height: 120px"
                                            *ngIf="Detail.UserSignature != null && Detail.UserSignature != ''"
                                            [src]="Detail.SignatureUrl" class="registrationImage mt-2">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card mt-3">
        <div class="card-header">
            <label>Company Lists</label>
        </div>
        <div class="card-body">
            <!-- <table datatable [dtOptions]="common.commonDToptions" [dtTrigger]="dtTrigger"
                class="table table-bordered pt-2" style="width: 100%; overflow: auto;"> -->

            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width: 5px;">Select</th>
                        <th style="width: 100%;">Company Name</th>
                        <!-- <th style="width: 10px;">Branch</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let element of CompanyMasterLoad ;let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="text-align: center;">
                            <input class="form-check-input" name="chk{{i}}" id="c{{i}}" type="checkbox"
                                [(ngModel)]="element.IsSelected" [checked]="element['IsSelected']" />
                        </td>
                        <td style="width: 100%;"> {{element['CompanyName']}}</td>
                        <!-- <td style="text-align: center;">
                            <button type="button" class="btn btn-sm btn-secondary" name="branch{{i}}" id="brch{{i}}"
                                (click)="openbranch(element)" [disabled]="Detail.Usertype === 'Administrator'">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Branch':'Loading...'}}
                            </button>
                        </td> -->
                    </tr>
                </tbody>
            </table>

        </div>
    </div>

    <hr>

    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-outline-primary btn-sm"
                [routerLink]="['/master/userdetail/usermaster']">Cancel</button>
        </div>
        <div class="col-auto">
            <button [disabled]="!Detail.IsActiveBackend" type="submit" class="btn btn-primary btn-sm">Save</button>
        </div>
    </div>

</form>